import React from "react"
import ShowData from "../src/components/ShowData"

class App extends React.Component {

  render() {

    return (
      <div className="App">
       <ShowData />
      </div>
    )
  }
}
export default App;
